import React from 'react';
import useAdminUserAddressesSWR from '../../../hooks/admin/useAdminUserAddressesSWR';
import { AdminUserAddress } from './AdminUserAddress';
import { ProfileLoadingLayout } from '../../layouts/LoadingLayouts/ProfileLoadingLayout';
import { ErrorTypography } from '../../styled/ErrorTypography';
import { AddressType } from '../../../models/Addresses';

export const AdminUserAddresses: React.FC<Props> = (props) => {
    const { userId, type, submitSuccess } = props;
    const { addresses, isLoading, isError, forceRefresh } =
        useAdminUserAddressesSWR(userId);

    if (isLoading) {
        return <ProfileLoadingLayout />;
    }

    if (isError) {
        return <ErrorTypography errorCode={'GLOBAL_ERROR'} />;
    }

    const handleForceRefresh = () => {
        forceRefresh().then((elem) => {});
        submitSuccess();
    };

    return (
        <>
            {type == 'shipping' &&
                addresses.map((address, key) => (
                    <AdminUserAddress
                        key={key}
                        type={'shipping'}
                        userId={props.userId}
                        address={address}
                        handleForceRefresh={handleForceRefresh}
                    />
                ))}
            {type == 'billing' && (
                <AdminUserAddress
                    type={'billing'}
                    userId={props.userId}
                    address={addresses[0]}
                    handleForceRefresh={handleForceRefresh}
                />
            )}
        </>
    );
};

interface Props {
    userId: number;
    type: AddressType;
    submitSuccess: () => void;
}
